/** Режим «отмена заказа / возврат» на checkout (Pet Taxi). */
export const REFUND_FLOW_KEY = 'payment_refund_flow';

export function activateRefundFlow() {
  try {
    sessionStorage.setItem(REFUND_FLOW_KEY, '1');
  } catch {
    /* ignore */
  }
}

export function clearRefundFlow() {
  try {
    sessionStorage.removeItem(REFUND_FLOW_KEY);
  } catch {
    /* ignore */
  }
}

export function isRefundFlowActive(searchParams) {
  if (searchParams?.get('refund') === '1') return true;
  try {
    return sessionStorage.getItem(REFUND_FLOW_KEY) === '1';
  } catch {
    return false;
  }
}

export function syncRefundFlowFromUrl(searchParams) {
  if (searchParams?.get('refund') === '1') activateRefundFlow();
  else clearRefundFlow();
}

export function buildRefundIndex2Path(index2Path) {
  const base = (index2Path || '').split('?')[0];
  return `${base}?refund=1`;
}
